<!-- Buy.vue -->
<template>
  <div class="main-content" v-if="detailInfo">
    <flex-line :is-link="true" :show-border="true" @click.native="changeCartState()">
      <div :class="{ 'isopacity': !activeBuy }">
        <p v-if="number <= 0 && chooseinfo.ids.length <= 0">
          {{ $t('PleaseSelectQuantityAndCategory') }}
        </p>
        <p v-if="number <= 0 && chooseinfo.ids.length > 0">
          {{ $t('SelectedWithQuantity1').replace(/{specification}/g, chooseinfo.specification.join(', ')).replace(/{number}/g, number + 1) }}
        </p>
        <p v-if="number > 0 && chooseinfo.ids.length <= 0">
          {{ $t('SelectedQuantity1').replace(/{number}/g, number) }}
        </p>
        <p v-if="number > 0 && chooseinfo.ids.length > 0">
          {{ $t('SelectedWithQuantity2').replace(/{specification}/g, chooseinfo.specification.join(', ')).replace(/{number}/g, number) }}
        </p>
      </div>
    </flex-line>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import flexLine from '../../../flexLine'
export default {
  data() {
    return {}
  },
  components: { flexLine },
  computed: {
    ...mapState({
      number: state => state.goodsdetail.number,
      detailInfo: state => state.goodsdetail.detailInfo,
      chooseinfo: state => state.goodsdetail.chooseinfo
    }),
    activeBuy: function () {
      if (this.detailInfo.goods_storage > 0) {
        return true
      } else {
        return false
      }
    },
  },

  created() { },

  watch: {
    detailInfo: function (value) {
      this.setSpecification()
    }
  },

  methods: {
    ...mapMutations({
      saveCartState: 'saveCartState',
      saveChooseInfo: 'saveChooseInfo',
      changeType: 'changeType'
    }),


    changeCartState() {
      this.saveCartState(true)
      this.changeType(this.$t('Add to cart'))
    },

    setSpecification() {
      if (this.detailInfo && this.detailInfo.properties) {
        let data = this.detailInfo.properties
        let arrays = []
        for (let i = 0; i <= data.length - 1; i++) {
          arrays.push(data[i].name)
        }
        this.saveChooseInfo({ specification: arrays, ids: [] })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.main-content {
  padding: 0 $pageSpace;
  background-color: #fff;
}

.isopacity {
  opacity: 0.5;
}
</style>
